import React from 'react';
import { useCompanyId } from '../../app/agistics-context';
import { PowerBIEmbed, } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import axios from 'axios';
import '../../styles/power-bi-reports.css'

interface EmbedResponse {
    accessToken: string,
    embedUrl: {
        reportId: string,
        reportName: string,
        embedUrl: string,
    }[],
    expiry: string,
    status: number
}

export const InteractiveReports: React.FC = () => {
    const companyId = useCompanyId();
    const [embedResponse, setEmbedResponse] = React.useState<EmbedResponse | undefined>();
    const [report, setReport] = React.useState<Report>();
    const [reportConfig, setReportConfig] = React.useState<models.IReportEmbedConfiguration>({
		type: 'report',
		embedUrl: undefined,
		tokenType: models.TokenType.Embed,
		accessToken: undefined,
		settings: undefined,
	});
    
    React.useEffect(() => {
        axios.get(`${API_BASE}/api/organizations/${companyId}/power-bi/getEmbedToken`)
            .then((response) => {
                console.log("embedTokenResponse", response);
                setEmbedResponse(response.data);
            })
            .catch((err) => {
                console.log("ERROR!", err);
            });
    }, []);

    React.useEffect(() => {
        console.log("EMBED RESPONSE!", embedResponse)
        let reportLoadConfig = {
            type: "report",
            tokenType: models.TokenType.Embed,
            accessToken: embedResponse?.accessToken,
            embedUrl: embedResponse?.embedUrl[0].embedUrl,
        }
        setReportConfig(reportLoadConfig)

        // Enable this setting to remove gray shoulders from embedded report
        // settings: {
        //     background: models.BackgroundType.Default
        // }

        // Use the token expiry to regenerate Embed token for seamless end user experience
        // Refer https://aka.ms/RefreshEmbedToken
        //let tokenExpiry = embedResponse?.expiry;

    }, [embedResponse]);

    return (
        <div style={{height:"100%"}}>
            <PowerBIEmbed
                embedConfig = {{
                    type: 'report',   // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                    id: embedResponse?.embedUrl[0].reportId,
                    embedUrl: embedResponse?.embedUrl[0].embedUrl,
                    accessToken: embedResponse?.accessToken,
                    tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
                    settings: {
                        panes: {
                            filters: {
                                expanded: false,
                                visible: false
                            }
                        },
                        background: models.BackgroundType.Transparent,
                    }
                }}
            
                eventHandlers = {
                    new Map([
                        ['loaded', function () {console.log('Report loaded');}],
                        ['rendered', function () {console.log('Report rendered');}],
                        ['error', function (event) {console.log(event?.detail);}],
                        ['visualClicked', () => console.log('visual clicked')],
                        ['pageChanged', (event) => console.log(event)],
                    ])
                }
            
                cssClassName = { "power-bi-report" }
            
                getEmbeddedComponent = { (embeddedReport) => {
                    setReport(embeddedReport as unknown as Report)
                }}
            />
            </div>
    );
};
